import React from 'react';
import PropTypes from 'prop-types';

import MerchantTile from 'core/modules/MerchantTile/MerchantTile';
import MerchantExperienceLink from 'core/modules/MerchantExperienceLink/MerchantExperienceLink';

function MerchantTileListItem({
  merchant, useAddToFavorite, useSmallerIcon, label, rebateOptions, trackingParams,
}) {
  return (
    <MerchantExperienceLink merchant={merchant} trackingParams={trackingParams}>
      <MerchantTile
        label={label}
        merchant={merchant}
        useAddToFavorite={useAddToFavorite}
        useSmallerIcon={useSmallerIcon}
        rebateOptions={rebateOptions}
      />
    </MerchantExperienceLink>
  );
}

MerchantTileListItem.propTypes = {
  merchant: PropTypes.shape({}).isRequired,
  useAddToFavorite: PropTypes.bool,
};

MerchantTileListItem.defaultProps = {
  useAddToFavorite: true,
};

export default MerchantTileListItem;
